export default {
	methods: {
		_buttonZoom(controlDiv, mapa) {
			controlDiv.style.margin = '10px'

			var zoomInButton = document.createElement('button')
			zoomInButton.className = 'btn btn-sm btn-default'
			zoomInButton.style.border = '0px'
			zoomInButton.style.marginRight = '2px'
			zoomInButton.title = 'Zoom In'
			controlDiv.appendChild(zoomInButton)

			var zoomOutButton = document.createElement('button')
			zoomOutButton.className = 'btn btn-sm btn-default'
			zoomOutButton.style.border = '0px'
			zoomOutButton.title = 'Zoom Out'
			controlDiv.appendChild(zoomOutButton)

			var iconePlus = document.createElement('span')
			iconePlus.className = 'fa fa-plus'
			iconePlus.style.fontSize = '16px'
			zoomInButton.appendChild(iconePlus)

			var iconeLess = document.createElement('span')
			iconeLess.className = 'fa fa-minus'
			iconeLess.style.fontSize = '16px'
			zoomOutButton.appendChild(iconeLess)

			zoomInButton.addEventListener('click', () => {
				mapa.setZoom(mapa.getZoom() + 1)
			})

			zoomOutButton.addEventListener('click', () => {
				mapa.setZoom(mapa.getZoom() - 1)
			})
		},

		_atualizaBotoes(mapa, botaoRoad, botaoSatelite, mapTypeId) {
			if (mapTypeId == 'terrain' && botaoRoad.className == 'btn btn-xs btn-default') {
				botaoRoad.className = 'btn btn-xs btn-info'
				botaoSatelite.className = 'btn btn-xs btn-default'
				if(!this._isMobile){
					document.getElementById("scales").checked = true
				}
				mapa.setMapTypeId(google.maps.MapTypeId.TERRAIN)
			} else if (mapTypeId == 'terrain' && botaoRoad.className == 'btn btn-xs btn-info' && (!document.getElementById("scales").checked && !this._isMobile)) {
				botaoRoad.className = 'btn btn-xs btn-primary'
				mapa.setMapTypeId(google.maps.MapTypeId.ROADMAP)
			}else if (mapTypeId == 'terrain' && botaoRoad.className == 'btn btn-xs btn-primary' && (document.getElementById("scales").checked && !this._isMobile)) {
				botaoRoad.className = 'btn btn-xs btn-info'
				mapa.setMapTypeId(google.maps.MapTypeId.TERRAIN)
			}else if (mapTypeId == 'hybrid' && botaoSatelite.className == 'btn btn-xs btn-default') {
				botaoSatelite.className = 'btn btn-xs btn-info'
				botaoRoad.className = 'btn btn-xs btn-default'
				if(!this._isMobile){
					document.getElementById("scales2").checked = true
				}
				mapa.setMapTypeId(google.maps.MapTypeId.HYBRID)
			}else if (mapTypeId == 'hybrid' && botaoSatelite.className == 'btn btn-xs btn-info' && (!document.getElementById("scales2").checked && !this._isMobile)){
				botaoSatelite.className = 'btn btn-xs btn-primary'
				mapa.setMapTypeId(google.maps.MapTypeId.SATELLITE)
			}else if (mapTypeId == 'hybrid' && botaoSatelite.className == 'btn btn-xs btn-primary' && (document.getElementById("scales2").checked && !this._isMobile)){
				botaoSatelite.className = 'btn btn-xs btn-info'
				mapa.setMapTypeId(google.maps.MapTypeId.HYBRID)
			}
		},

		_tipoMapa(tipo_mapa, mapa) {
			tipo_mapa.style.marginTop = '10px'

			var road = document.createElement('button')
			road.type = 'button'
			road.style.border = '0px'
			road.className = 'btn btn-xs btn-info'
			road.innerHTML = '<i class="fa fa-fw fa-map"></i> ' + this._traducao('global', 'mapa').toUpperCase()
			road.style.padding = '5px'
			road.style.fontSize = '12px'
			road.style.marginRight = '2px'
			tipo_mapa.appendChild(road)

			var relevo = document.createElement('ul')
			relevo.style.listStyle = 'none'
			relevo.style.position = 'absolute'
			relevo.style.left = '0'
			relevo.style.padding = '0'
			relevo.style.margin = '0'
			relevo.style.top = 'calc(100% + 1px)'
			relevo.style.display = 'none'
			relevo.style.alignItems = 'center'
			relevo.style.justifyContent = 'center'
			relevo.style.textAlign = 'center'
			relevo.style.border = '0px'
			relevo.innerHTML = '<li style="color: black; background-color: rgb(255, 255, 255); padding: 5px 8px 5px 5px; white-space: nowrap; border-radius: 2px;"><input type="checkbox" id="scales" name="scales" style="margin: 0;" checked><label style="cursor: inherit; margin: 0; margin-left: 2px;">Relevo</label></li>'
			road.appendChild(relevo)

			var satelite = document.createElement('button')
			satelite.type = 'button'
			satelite.style.border = '0px'
			satelite.className = 'btn btn-xs btn-default'
			satelite.innerHTML = '<i class="fa fa-globe fa-fw"></i> ' + this._traducao('global', 'satelite').toUpperCase()
			satelite.style.padding = '5px'
			satelite.style.fontSize = '12px'
			tipo_mapa.appendChild(satelite)

			var marcadores = document.createElement('ul')
			marcadores.style.listStyle = 'none'
			marcadores.style.position = 'absolute'
			marcadores.style.right = '0'
			marcadores.style.padding = '0'
			marcadores.style.margin = '0'
			marcadores.style.top = 'calc(100% + 1px)'
			marcadores.style.display = 'none'
			marcadores.style.alignItems = 'center'
			marcadores.style.justifyContent = 'center'
			marcadores.style.textAlign = 'center'
			marcadores.style.border = '0px'
			marcadores.innerHTML = '<li style="color: black; background-color: rgb(255, 255, 255); padding: 5px 3px 5px 3px; white-space: nowrap; border-radius: 2px;"><input type="checkbox" id="scales2" name="scales2" style="margin: 0;" checked><label style="cursor: inherit; margin: 0; margin-left: 2px;">Marcadores</label></li>'
			satelite.appendChild(marcadores)

			/* road.addEventListener('mouseenter', () => {
				if(road.className == 'btn btn-xs btn-info'){
					relevo.style.display = 'block'
				}
			}) */

			road.addEventListener('mouseleave', () => {
				setTimeout(() => {
					relevo.style.display = 'none'
				}, 2000)
			})

			road.addEventListener('click', () => {
				this._atualizaBotoes(mapa, road, satelite, 'terrain')
				relevo.style.display = 'block'
			})

			/* satelite.addEventListener('mouseenter', () => {
				if(satelite.className == 'btn btn-xs btn-info'){
					marcadores.style.display = 'block'
				}
			}) */

			satelite.addEventListener('mouseleave', () => {
				setTimeout(() => {
					marcadores.style.display = 'none'
				}, 2000)
			})

			satelite.addEventListener('click', () => {
				this._atualizaBotoes(mapa, road, satelite, 'hybrid')
				marcadores.style.display = 'block'
			})

			mapa.addListener('maptypeid_changed', () => {
				this._atualizaBotoes(mapa, road, satelite, mapa.getMapTypeId())
			})
		},

		_adicionaBotaoMensagem(mapa) {
			let btnMensagem = document.createElement('div')

			btnMensagem.style.marginTop = '10px'
			btnMensagem.style.marginRight = '20px'

			let button = document.createElement('button')
			button.type = 'button'
			button.style.border = '0px'
			button.className = 'btn btn-xs btn-default'
			button.innerHTML = '<i class="fa fa-fw fa-comment" aria-hidden="true"></i> MENSAGENS'
			button.style.padding = '5px'
			button.style.fontSize = '12px'
			button.style.marginRight = '5px'
			btnMensagem.appendChild(button)

			button.addEventListener('click', () => {
				if (button.className == 'btn btn-xs btn-default') {
					button.className = 'btn btn-xs btn-info'
				} else {
					button.className = 'btn btn-xs btn-default'
				}
			})

			mapa.controls[google.maps.ControlPosition.TOP_RIGHT].push(btnMensagem)
		},

		_adicionaBotaoMotivo(mapa, descricao) {
			let btnMotivo = document.createElement('div')

			btnMotivo.style.marginTop = '10px'
			btnMotivo.style.marginRight = '8px'

			let button = document.createElement('button')
			button.type = 'button'
			button.style.border = '0px'
			button.className = 'btn btn-xs btn-default'
			button.innerHTML = '<i class="fa fa-share fa-fw"></i> ' + descricao
			button.style.padding = '5px'
			button.style.fontSize = '12px'
			button.style.marginRight = '5px'
			btnMotivo.appendChild(button)

			button.addEventListener('click', () => {
				if (button.className == 'btn btn-xs btn-default') {
					button.className = 'btn btn-xs btn-info'
				} else {
					button.className = 'btn btn-xs btn-default'
				}
			})

			mapa.controls[google.maps.ControlPosition.TOP_RIGHT].push(btnMotivo)
		},

		_adicionaBotaoCentralizar(mapa) {
			let btnCentralizar = document.createElement('div')

			btnCentralizar.style.marginTop = '10px'
			btnCentralizar.style.marginRight = '8px'

			let button = document.createElement('button')
			button.type = 'button'
			button.style.border = '0px'
			button.className = 'btn btn-xs btn-default'
			button.innerHTML = '<i class="fa fa-fw fa fa-dot-circle-o fa-fw"></i> CENTRALIZAR'
			button.style.padding = '5px'
			button.style.fontSize = '12px'
			button.style.marginRight = '5px'
			btnCentralizar.appendChild(button)

			button.addEventListener('click', () => {
				if (button.className == 'btn btn-xs btn-default') {
					button.className = 'btn btn-xs btn-info'
				} else {
					button.className = 'btn btn-xs btn-default'
				}
			})

			mapa.controls[google.maps.ControlPosition.TOP_RIGHT].push(btnCentralizar)
		},

		_tipoMapaMobile(tipo_mapa, mapa) {
			tipo_mapa.style.margin = '55px 10px'

			var road = document.createElement('button')
			road.type = 'button'
			road.style.border = '0px'
			road.className = 'btn btn-xs btn-info'
			road.innerHTML = '<i class="fa fa-fw fa-map"></i> MAPA'
			road.style.padding = '10px 11px'
			road.style.fontSize = '12px'
			road.style.marginRight = '2px'
			road.style.boxShadow = 'rgba(0, 0, 0, 0.298039) 0px 1px 4px -1px'
			tipo_mapa.appendChild(road)

			var satelite = document.createElement('button')
			satelite.type = 'button'
			satelite.style.border = '0px'
			satelite.className = 'btn btn-xs btn-default'
			satelite.innerHTML = '<i class="fa fa-globe fa-fw"></i> SATÉLITE'
			satelite.style.padding = '10px 11px'
			satelite.style.fontSize = '12px'
			satelite.style.boxShadow = 'rgba(0, 0, 0, 0.298039) 0px 1px 4px -1px'
			tipo_mapa.appendChild(satelite)

			road.addEventListener('click', () => {
				this._atualizaBotoes(mapa, road, satelite, 'terrain')
			})

			satelite.addEventListener('click', () => {
				this._atualizaBotoes(mapa, road, satelite, 'hybrid')
			})

			mapa.addListener('maptypeid_changed', () => {
				this._atualizaBotoes(mapa, road, satelite, mapa.getMapTypeId())
			})
		},

		_adicionaBotoes(mapa) {
			var zoomControlDiv = document.createElement('div')
			var mapa_tipo = document.createElement('div')

			if (this._isMobile) {
				this._tipoMapaMobile(mapa_tipo, mapa)
				mapa.controls[google.maps.ControlPosition.TOP_LEFT].push(mapa_tipo)
			} else {
				this._buttonZoom(zoomControlDiv, mapa)
				mapa.controls[google.maps.ControlPosition.TOP_RIGHT].push(zoomControlDiv)

				this._tipoMapa(mapa_tipo, mapa)
				mapa.controls[google.maps.ControlPosition.TOP_RIGHT].push(mapa_tipo)
			}
		}
	}
}
